import { render, staticRenderFns } from "./ServiceTranslationEditPopup.vue?vue&type=template&id=4191031c&"
import script from "./ServiceTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./ServiceTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports